import { gql } from '@apollo/client';

// 獲取投票文章列表
export const GET_VOTING_ARTICLES = gql`
  query GetVotingArticles($limit: Int, $skip: Int, $sortBy: VotingArticleSortBy, $searchTerm: String, $tagId: ID, $userId: ID, $onlyRecommended: Boolean) {
    votingArticles(limit: $limit, skip: $skip, sortBy: $sortBy, searchTerm: $searchTerm, tagId: $tagId, userId: $userId, onlyRecommended: $onlyRecommended) {
      success
      message
      articles {
        id
        status
        allowComments
        showVoteResults
        isAnonymous
        isRecommended
        creatorId
        creator {
          id
          username
        }
        voteCount
        commentCount
        viewCount
        favoriteCount
        voteResults {
          optionIndex
          count
          percentage
        }
        userVote {
          id
          selectedOption
          votedAt
        }
        question {
          id
          title
          description
          options {
            text
            order
          }
          tags {
            id
            name
            description
          }
          secret
        }
        isFavorited
        isInQuestionSet
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

// 獲取投票攻略
export const GET_VOTING_STRATEGY = gql`
  query GetVotingStrategy {
    votingStrategy {
      success
      message
      articles {
        id
        status
        allowComments
        showVoteResults
        isAnonymous
        isRecommended
        creatorId
        creator {
          id
          username
        }
        voteCount
        commentCount
        viewCount
        favoriteCount
        voteResults {
          optionIndex
          count
          percentage
        }
        userVote {
          id
          selectedOption
          votedAt
        }
        question {
          id
          title
          description
          options {
            text
            order
          }
          tags {
            id
            name
            description
          }
          secret
        }
        isFavorited
        isInQuestionSet
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

// 獲取單個投票文章
export const GET_VOTING_ARTICLE = gql`
  query GetVotingArticle($id: ID!) {
    votingArticle(id: $id) {
      success
      message
      article {
        id
        status
        allowComments
        showVoteResults
        isAnonymous
        isRecommended
        creatorId
        creator {
          id
          username
        }
        voteCount
        commentCount
        viewCount
        favoriteCount
        voteResults {
          optionIndex
          count
          percentage
        }
        userVote {
          id
          selectedOption
          votedAt
        }
        question {
          id
          title
          description
          options {
            text
            order
          }
          tags {
            id
            name
            description
          }
          secret
        }
        isInQuestionSet
        createdAt
        updatedAt
      }
    }
  }
`;

// 創建投票
export const CREATE_VOTE = gql`
  mutation CreateVote($input: CreateVoteInput!) {
    createVote(input: $input) {
      success
      message
      vote {
        id
        articleId
        userId
        selectedOption
        votedAt
      }
    }
  }
`;

// 更新投票
export const UPDATE_VOTE = gql`
  mutation UpdateVote($input: UpdateVoteInput!) {
    updateVote(input: $input) {
      success
      message
      vote {
        id
        articleId
        userId
        selectedOption
        votedAt
      }
    }
  }
`;

// 創建投票文章
export const CREATE_VOTING_ARTICLE = gql`
  mutation CreateVotingArticle($input: CreateVotingArticleInput!) {
    createVotingArticle(input: $input) {
      success
      message
      article {
        id
        status
        creatorId
        createdAt
      }
    }
  }
`;

// 更新投票文章
export const UPDATE_VOTING_ARTICLE = gql`
  mutation UpdateVotingArticle($input: UpdateVotingArticleInput!) {
    updateVotingArticle(input: $input) {
      success
      message
      article {
        id
        status
        updatedAt
      }
    }
  }
`;

// 刪除投票文章
export const DELETE_VOTING_ARTICLE = gql`
  mutation DeleteVotingArticle($id: ID!) {
    deleteVotingArticle(id: $id) {
      success
      message
    }
  }
`;

// 創建評論
export const CREATE_COMMENT = gql`
  mutation CreateComment($input: CreateCommentInput!) {
    createComment(input: $input) {
      success
      message
      errors {
        field
        message
      }
      comment {
        id
        content
        authorId
        author {
          username
        }
        isAnonymous
        createdAt
      }
    }
  }
`;

// 獲取評論列表
export const GET_COMMENTS = gql`
  query GetComments($articleId: ID!, $limit: Int, $skip: Int) {
    articleComments(articleId: $articleId, limit: $limit, skip: $skip) {
      success
      message
      comments {
        id
        content
        authorId
        author {
          id
          username
        }
        parentId
        isAnonymous
        likeCount
        replyCount
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

// 切換收藏狀態
export const TOGGLE_FAVORITE = gql`
  mutation ToggleFavorite($articleId: ID!) {
    toggleFavorite(articleId: $articleId) {
      success
      message
      favorite {
        id
        articleId
        userId
        favoritedAt
      }
    }
  }
`;

// 切換推薦狀態（僅半管理者）
export const TOGGLE_VOTING_RECOMMENDATION = gql`
  mutation ToggleVotingRecommendation($articleId: ID!) {
    toggleVotingRecommendation(articleId: $articleId) {
      success
      message
      article {
        id
        isRecommended
      }
      errors {
        field
        message
      }
    }
  }
`;

// 獲取我的投票文章
export const GET_MY_VOTING_ARTICLES = gql`
  query GetMyVotingArticles {
    myVotingArticles {
      success
      message
      articles {
        id
        status
        allowComments
        showVoteResults
        isAnonymous
        isRecommended
        creatorId
        creator {
          id
          username
        }
        question {
          id
          title
          description
          options {
            text
            order
          }
        }
        voteCount
        commentCount
        viewCount
        favoriteCount
        voteResults {
          optionIndex
          count
          percentage
        }
        userVote {
          id
          selectedOption
          votedAt
        }
        question {
          id
          title
          description
          options {
            text
            order
          }
          tags {
            id
            name
            description
          }
          secret
        }
        isFavorited
        isInQuestionSet
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

// 獲取我的收藏投票
export const GET_MY_FAVORITES = gql`
  query GetMyFavorites {
    myFavorites {
      success
      message
      favorites {
        id
        articleId
        favoritedAt
        article {
          id
          status
          isAnonymous
          isRecommended
          creatorId
          creator {
            id
            username
          }
          question {
            id
            title
            description
            options {
              text
              order
            }
          }
          voteCount
          commentCount
          viewCount
          favoriteCount
          voteResults {
            optionIndex
            count
            percentage
          }
          userVote {
            id
            selectedOption
            votedAt
          }
          question {
            id
            title
            description
            options {
              text
              order
            }
            tags {
              id
              name
              description
            }
          }
          isFavorited
          createdAt
          updatedAt
        }
      }
      totalCount
    }
  }
`;

// 獲取特定使用者的尚未作答的必答題
export const GET_USER_UNANSWERED_REQUIRED_ARTICLES = gql`
  query GetUserUnansweredRequiredArticles($userId: ID!, $limit: Int, $skip: Int) {
    userUnansweredRequiredArticles(userId: $userId, limit: $limit, skip: $skip) {
      success
      message
      articles {
        id
        status
        allowComments
        showVoteResults
        isAnonymous
        isRecommended
        creatorId
        creator {
          id
          username
        }
        voteCount
        commentCount
        viewCount
        favoriteCount
        voteResults {
          optionIndex
          count
          percentage
        }
        userVote {
          id
          selectedOption
          votedAt
        }
        question {
          id
          title
          description
          options {
            text
            order
          }
          tags {
            id
            name
            description
          }
          secret
        }
        isFavorited
        isInQuestionSet
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

// 搜索投票文章
export const SEARCH_VOTING_ARTICLES = gql`
  query SearchVotingArticles($searchTerm: String!, $limit: Int, $skip: Int, $sortBy: VotingArticleSortBy) {
    searchVotingArticles(searchTerm: $searchTerm, limit: $limit, skip: $skip, sortBy: $sortBy) {
      success
      message
      articles {
        id
        status
        allowComments
        showVoteResults
        isAnonymous
        isRecommended
        creatorId
        creator {
          id
          username
        }
        voteCount
        commentCount
        viewCount
        favoriteCount
        voteResults {
          optionIndex
          count
          percentage
        }
        userVote {
          id
          selectedOption
          votedAt
        }
        question {
          id
          title
          description
          options {
            text
            order
          }
          tags {
            id
            name
            description
          }
          secret
        }
        isFavorited
        isInQuestionSet
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

// 檢舉文章
export const REPORT_ARTICLE = gql`
  mutation ReportArticle($articleId: ID!, $reason: ReportReason!) {
    reportArticle(articleId: $articleId, reason: $reason) {
      success
      message
      report {
        id
        articleId
        reporterId
        reason
        falseAlarm
        createdAt
      }
      errors {
        field
        message
      }
    }
  }
`;

// 將某篇文章的所有檢舉標記為誤報（僅半管理員）
export const MARK_ARTICLE_REPORTS_AS_FALSE_ALARM = gql`
  mutation MarkArticleReportsAsFalseAlarm($articleId: ID!) {
    markArticleReportsAsFalseAlarm(articleId: $articleId) {
      success
      message
      report {
        id
        articleId
        reporterId
        reason
        falseAlarm
        createdAt
      }
      errors {
        field
        message
      }
    }
  }
`;

// 獲取被檢舉的文章列表（僅半管理員）
export const GET_REPORTED_ARTICLES = gql`
  query GetReportedArticles(
    $limit: Int
    $skip: Int
    $falseAlarmFilter: ReportedArticleFalseAlarmFilter
    $isReported: Boolean
    $isRecommended: Boolean
    $sortBy: ReportedArticleSortBy
  ) {
    reportedArticles(
      limit: $limit
      skip: $skip
      falseAlarmFilter: $falseAlarmFilter
      isReported: $isReported
      isRecommended: $isRecommended
      sortBy: $sortBy
    ) {
      success
      message
      articles {
        article {
          id
          status
          allowComments
          showVoteResults
          isAnonymous
          isRecommended
          creatorId
          creator {
            id
            username
          }
          voteCount
          commentCount
          viewCount
          favoriteCount
          voteResults {
            optionIndex
            count
            percentage
          }
          question {
            id
            title
            description
            options {
              text
              order
            }
            tags {
              id
              name
              description
            }
            secret
          }
          createdAt
          updatedAt
        }
        reportCount
        falseAlarmCount
        hasFalseAlarm
        allFalseAlarm
      }
      totalCount
      errors {
        field
        message
      }
    }
  }
`; 